import React, { forwardRef } from 'react';

const ExclamationTriangleIcon = forwardRef(
  ({ customFontSize, ...props }, ref) => {
    return (
      <i
        ref={ref}
        {...props}
        className={'fad fa-exclamation-triangle '}
        style={{
          fontSize: customFontSize || '16px',
          marginLeft: '5px',
          '--fa-secondary-color': 'orange',
          '--fa-primary-color': '#000000',
          ...props.style
        }}
      ></i>
    );
  }
);

export default ExclamationTriangleIcon;
